<template>
  <div>
    <a-button type="primary" @click="getList">
      {{ $t('refresh') }}
    </a-button>
    <a-input-search
        v-model="gatewayCodeSelect"
        style="width:250px;float: right"
        allowClear
        :placeholder="$t('请输入网关编号')"
        :enterButton="$t('search')"
        @search="() => search()"
    />
    <a-table :columns="columns"
             :data-source="data"
             :expandIconColumnIndex="iconColumnIndex"
             :ndentSize="'15'"
    >
      <a-table
          slot="expandedRowRender"
          slot-scope="record"
          size="default"
          style="margin:0 0 -6px"
          :columns="innerColumns"
          :data-source="record.webNodeList"
          :pagination="false"
      >
        <span slot="action" slot-scope="text, record">
          <a-popconfirm
              title="确定剔除该节点吗?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirmRemoteWebNode(record.userName)"
          >
          <a-button type="link">剔除</a-button>
          </a-popconfirm>
      </span>
      </a-table>

      <span slot="action" slot-scope="text, record">
      <a-popconfirm
          title="确定剔除该节点吗?"
          ok-text="确定"
          cancel-text="取消"
          @confirm="confirmRemoteNode(record.gatewayCode)"
      >
        <a-button type="link">剔除</a-button>
      </a-popconfirm>
        </span>
    </a-table>
  </div>
</template>

<script>

import dayjs from "dayjs";
import {NodeServiceProxy, OfflineNodeDto} from "@/service-proxies/app-v2/iot-remoteterminal-v2.service-proxies";

const escp = new NodeServiceProxy()
export default {
  name: "GatewatNode",
  data() {
    return {
      gatewayCodeSelect:'',
      data: [],
      iconColumnIndex: 0,
      columns: [
        {
          title: '操作',
          key: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          width: 100,
        },
        {
          title: '连接数',
          key: 'webNodeList',
          dataIndex: 'webNodeList',
          width: 100,
          scopedSlots: {
            customRender: 'webNodeList'
          },
          customRender: (item) =>  item.length
        },
        {
          title: '网关编号',
          dataIndex: 'gatewayCode',
          key: 'gatewayCode',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
          width: 100,
        },
        {
          title: '登录时间',
          dataIndex: 'utcLoginTime',
          key: 'utcLoginTime',
          scopedSlots: {
            customRender: 'utcLoginTime'
          },
          width: 100,
          customRender: (time) => dayjs(time).format("YYYY-MM-DD HH:mm:ss"),
        }
      ],
      innerColumns:[
        {
          title: '操作',
          key: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          width: 100,
        },
        {
          title: '用户',
          dataIndex: 'userName',
          key: 'userName',
          width: 100,

        },
        {
          title: '网关编号',
          dataIndex: 'gatewayCode',
          key: 'gatewayCode',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
          width: 100,
        },
        {
          title: '登录时间',
          dataIndex: 'utcLoginTime',
          key: 'utcLoginTime',
          scopedSlots: {
            customRender: 'utcLoginTime'
          },
          width: 100,
          customRender: (time) => dayjs(time).format("YYYY-MM-DD HH:mm:ss"),
        }
      ]
    }
  },
  props: {},
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.gatewayCodeSelect = ''
      escp.findGatewayNodeList().then(res => {
        if (res) {
          this.data = res.data
        }
      })
    },
    confirmRemoteNode(nodeId) {
      let dto = new OfflineNodeDto()
      dto.nodeId = nodeId
      escp.offlineGatewayNode(dto).then((res) => {
        this.getList()
      })
    },
    confirmRemoteWebNode(nodeId){
      let dto = new OfflineNodeDto()
      dto.nodeId = nodeId
      escp.offlineWebNode(dto).then((res) =>{
        this.getList()
      })
    },
    search(){
      escp.findGatewayNodeList()
          .then(res => {
            let newData = res.data;
            this.data = newData
            if (this.gatewayCodeSelect){
              this.data = newData.filter( (item) => item.gatewayCode.indexOf(this.gatewayCodeSelect.trim().toUpperCase()) != -1)
            }
          })
    }
  }
}
</script>

<style scoped>

</style>